import { render, staticRenderFns } from "./totalByGroup.vue?vue&type=template&id=23322a41&"
import script from "./totalByGroup.vue?vue&type=script&lang=js&"
export * from "./totalByGroup.vue?vue&type=script&lang=js&"
import style0 from "./totalByGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports